export default __webpack_public_path__ + "dd09825ad3105b74f90e97f4dacb01b7.gif";